export default async function obtenerDirecciones(idContribuyente) {
    const endpoint = `/api/direccion/obtenerPorIdContribuyente/${idContribuyente}`;
    try {
        const response = await fetch(endpoint);
        if (response.status === 400) return [];
        const { data } = await response.json();
        return data;
    } catch (_) {
        return [];
    }
}
